export const SOCIAL_LINKS = {
	WHATSAPP: {
		PHONE: '+62087781820345',
		DEFAULT_MESSAGE:
			'Halo Ketaren Transport, boleh minta price list untuk rental mobil + driver? Terima kasih'
	}
};
